import {
    getFunctions,
    httpsCallable,
    HttpsCallableResult,
} from 'firebase/functions';
import { Region } from '../../redux/phio/phioRedux.types';
import { callFunction } from '../functions';

export default function lookupRegion(customerName: string) {
    return callFunction<
        { customer_name: string },
        {
            status: number;
            database_id: string;
            region: Region;
            validated: boolean;
        }
    >('bootup-region', {
        customer_name: customerName,
    });
}

export async function getDatabaseIdFromRegion(region: Region) {
    const getAllRegions = () =>
        callFunction<
            undefined,
            {
                regions: Array<{ key: string; value: string; label: string }>;
                status: number;
            }
        >('intl-regions');
    const { regions } = (await getAllRegions()).data;

    return regions.find(({ key }) => key === region)?.value;
}

export async function misconfiguredUrl(
    pathname: string,
): Promise<HttpsCallableResult> {
    return httpsCallable(
        getFunctions(),
        'bootup-misconfiguredurl',
    )({ pathname });
}
